module.exports = "<router-outlet></router-outlet>\r\n<loading-overlay \r\n    [loading]=\"loading$ | async\"\r\n    >\r\n</loading-overlay>\r\n<pause-screen *ngIf=\"isPauseScreenVisible$ | async\"></pause-screen>\r\n<lock-screen *ngIf=\"isLockScreenVisible$ | async\"></lock-screen>\r\n<exit-screen *ngIf=\"isExitScreenVisible$ | async\"></exit-screen>\r\n<generic-page></generic-page>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.component.html
// module id = efyd
// module chunks = 1